import { render, staticRenderFns } from "./PropostaPrecoHistorico.vue?vue&type=template&id=5f4bf4b2&scoped=true&"
import script from "./PropostaPrecoHistorico.vue?vue&type=script&lang=js&"
export * from "./PropostaPrecoHistorico.vue?vue&type=script&lang=js&"
import style0 from "./PropostaPrecoHistorico.vue?vue&type=style&index=0&id=5f4bf4b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4bf4b2",
  null
  
)

export default component.exports